/**
 * @generated SignedSource<<74eccdeb13960157eb4e0fa270277078>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteCustomFieldDefinitionInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteCustomFieldDefinitionMutation$variables = {
  input: DeleteCustomFieldDefinitionInput;
};
export type deleteCustomFieldDefinitionMutation$data = {
  readonly deleteCustomFieldDefinition: {
    readonly deletedCustomFieldDefinitionId: string | null;
  } | null;
};
export type deleteCustomFieldDefinitionMutation = {
  variables: deleteCustomFieldDefinitionMutation$variables;
  response: deleteCustomFieldDefinitionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "deleteCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCustomFieldDefinitionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9d7a1a9e4f5c99f60a2c3862b791efdd",
    "id": null,
    "metadata": {},
    "name": "deleteCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation deleteCustomFieldDefinitionMutation(\n  $input: DeleteCustomFieldDefinitionInput!\n) {\n  deleteCustomFieldDefinition(input: $input) {\n    deletedCustomFieldDefinitionId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8965de18e7dfd48b49d333d333621eb";

export default node;
